export interface Todo {
  id: string;
  title: string;
  createdAt: Date;
  deadline: Date;
  completed: boolean;
  completedAt?: Date;
  pointsEarned?: number;
  isOverdrive?: boolean;
  missionId?: string;
}

export interface UserProgress {
  totalPoints: number;
  currentLevel: number;
  lastResetDate: string;
}

export interface CompletionTiming {
  isEarly: boolean;
  progressPercent: number;
}

export enum MissionSize {
  S = 'S',
  M = 'M',
  L = 'L',
  XL = 'XL',
  XXL = 'XXL'
}

export interface Mission {
  id: string;
  name: string;
  size: MissionSize;
  requiredTodos: number;
  completedTodos: number;
  createdAt: Date;
  isCompleted: boolean;
  isGeneral?: boolean;
}